module.exports = __webpack_public_path__ + "img/374.21f8c757.jpg";